import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CardBloc } from '@kp/shared/components/cards/card.bloc';
import { CustomCardCategory } from '@ktypes/enums';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-detail-card-loader',
  templateUrl: './detail-card-loader.component.html',
  styleUrls: ['./detail-card-loader.component.scss'],
})
export class DetailCardLoaderComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  constructor(public cardBloc: CardBloc, private route: ActivatedRoute) {}

  ngOnInit() {
    combineLatest([this.route.paramMap, this.route.data, this.route.parent?.paramMap])
      .pipe(takeUntil(this._destroy$))
      .subscribe(([paramMap, data, parentParamMap]) => {
        this.cardBloc.getCardByContentId(
          paramMap.get('id'),
          data.screen,
          parentParamMap.get('category') as CustomCardCategory
        );
      });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
